/**
 * The two verification calls over the API wrapper. The code lookup is public, so the
 * public page calls it without a token (`auth: false`).
 */
import { apiFetch } from '@/api/client'
import type { SearchHit, SearchQuery, VerifyCodeResult } from './types'

export interface CallOptions {
  auth?: boolean
  signal?: AbortSignal
}

export function periksaKode(kode: string, options: CallOptions = {}): Promise<VerifyCodeResult> {
  return apiFetch<VerifyCodeResult>('/verify', { query: { kode }, ...options })
}

export function cariCatatan(
  query: SearchQuery,
  options: CallOptions = {},
): Promise<{ hasil: SearchHit[] }> {
  return apiFetch<{ hasil: SearchHit[] }>('/verify/search', { query: { ...query }, ...options })
}
